import i18n from '@/lang' // internationalization
import Big from 'big.js'
const filters = {
  // 保留两位小数的
  KeepTwo: function (value) {
    if (typeof value !== 'undefined' && value !== null && !isNaN(value)) {
      if (isNaN(Number(value).toFixed(2))) {
        return '--'
      } else {
        return Number(value).toFixed(2)
      }
    } else {
      return '--'
    }
  },
  // 保留两位小数 不四舍五入
  KeepTwoNum: function (value) {
    if (typeof value !== 'undefined' && value !== null && !isNaN(value)) {
      if (isNaN(Number(value).toFixed(2))) {
        return '--'
      } else {
        if (Number(value) === 0) {
          return value
        }
        const flag = String(value).indexOf('.')
        if (!flag) {
          return value
        } else {
          const val = String(value).substring(0, flag + 3)
          return val
        }
      }
    } else {
      return '--'
    }
  },
  // 根据服务类型显示成交量
  VolumeByServerType: function (value, serverType) {
    let val = ''
    switch (serverType) {
      case 3:
        val = value
        break
      case 5:
        val = value
        break
      case 4:
        /**
         * 方达不需要处理了
         */
        // val = value / 100000
        val = value
        break
      case 2:
        val = value / 100
        break
      case 1:
        val = value / 10000
        break
    }
    return val
    // return +serverType === SERVERTYPE.sirix || +serverType === 5
    //   ? value
    //   : serverType === 4
    //   ? value / 100000
    //   : +serverType === SERVERTYPE.mt4
    //   ? value / 100
    //   : value / (+serverType === SERVERTYPE.mt5 ? 10000 : 100)
  },

  // 加个保留指定小数
  priceKeepFiexd: function (value, keep) {
    if (typeof value !== 'undefined' && value !== null && !isNaN(value)) {
      if (keep) {
        if (isNaN(Number(value).toFixed(keep))) {
          return '--'
        } else {
          return Number(value).toFixed(keep)
        }
      } else {
        if (isNaN(Number(value).toFixed(5))) {
          return '--'
        } else {
          return Number(value).toFixed(5)
        }
      }
    } else {
      return '--'
    }
  },
  // 判断是否为undefined 与添加类型语言包
  ifUndefined: function (val) {
    if (val) {
      return val
    } else {
      return '--'
    }
  },

  // 时间戳转化
  disposeDate: function (val) {
    // eslint-disable-next-line no-extend-native
    Date.prototype.Format = function (fmt) {
      const o = {
        'M+': this.getMonth() + 1, // 月份
        'd+': this.getDate(), // 日
        'H+': this.getHours(), // 小时
        'm+': this.getMinutes(), // 分
        's+': this.getSeconds(), // 秒
        'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
        S: this.getMilliseconds() // 毫秒
      }
      // eslint-disable-next-line no-param-reassign
      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, String(this.getFullYear()).substr(4 - RegExp.$1.length))
      for (const k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          // eslint-disable-next-line no-param-reassign
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(String(o[k]).length))
      return fmt
    }
    if (val) {
      // eslint-disable-next-line no-useless-concat
      return new Date(val).Format('yyyy-MM-dd ' + ' HH:mm:ss')
    } else {
      return '--'
    }
  },

  // 生日时间戳转化
  birthday: function (val) {
    // eslint-disable-next-line no-extend-native
    Date.prototype.Format = function (fmt) {
      const o = {
        'M+': this.getMonth() + 1, // 月份
        'd+': this.getDate(), // 日
        'H+': this.getHours(), // 小时
        'm+': this.getMinutes(), // 分
        's+': this.getSeconds(), // 秒
        'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
        S: this.getMilliseconds() // 毫秒
      }
      // eslint-disable-next-line no-param-reassign
      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, String(this.getFullYear()).substr(4 - RegExp.$1.length))
      for (const k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          // eslint-disable-next-line no-param-reassign
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(String(o[k]).length))
      return fmt
    }
    if (val) {
      return new Date(val).Format('yyyy-MM-dd')
    } else {
      return ''
    }
  },
  // 截取小数点后两位 不进行四舍五入
  moneyFult: function (val) {
    const big = new Big(val || 0)
    const srt = String(big.toFixed())
    let num = 0
    if (srt.indexOf('.') === -1) {
      num = srt.length + 1
    } else {
      num = srt.indexOf('.') + 3
    }
    return srt.substring(0, num)
  },
  // 显示交易类型
  tradeType: function (val) {
    if (typeof val !== 'undefined' && val !== null) {
      if (val % 2 === 0) {
        return 'BUY'
      } else {
        return 'SELL'
      }
    } else {
      return '--'
    }
  },
  // 交易类型格式化
  tradeTypeFormat(val) {
    if (typeof val !== 'undefined' && val !== null) {
      switch (val) {
        case 0:
          return 'BUY'
        case 1:
          return 'SELL'
        default:
          return '--'
      }
    } else {
      return '--'
    }
  },
  getEntry(entry) {
    let _entry = '--'
    switch (entry) {
      case 0:
        _entry = 'in'
        break
      case 1:
        _entry = 'out'
        break
      case 2:
        _entry = 'in/out'
        break
      case 3:
        _entry = 'out by'
        break
    }
    return _entry
  },
  // 交易类型判断奇偶数
  oddEvenType: function (val) {
    if (typeof val !== 'undefined' && val !== null) {
      if (val % 2 === 0) {
        return 'BUY'
      } else {
        return 'SELL'
      }
    } else {
      return '--'
    }
  },
  // 操作类型
  operatType: (val) => {
    if (val) {
      if (String(val) === '1') {
        return i18n.t('AuditRecord.Deposit')
      }
      if (String(val) === '2') {
        return i18n.t('AuditRecord.Withdrawal')
      }
      if (String(val) === '3') {
        return i18n.t('PurseFlow.Transfer')
      }
      if (String(val) === '4') {
        return i18n.t('PurseFlow.Rebate')
      }
      return '--'
    } else {
      return '--'
    }
  },
  // 操作方式
  // eslint-disable-next-line complexity
  operatWays: (ways, type) => {
    if (String(type) === '1') {
      if (String(ways) === '1') {
        return i18n.t('PurseFlow.WireTransfer') // 国际电汇
      }
      if (String(ways) === '2') {
        return i18n.t('PurseFlow.BankTransfer') // 银行汇款
      }
      if (String(ways) === '3') {
        return i18n.t('PurseFlow.Refundofwithdrawal') // 回撤出金
      }
      if (String(ways) === '4') {
        return i18n.t('PurseFlow.SystematicDeposit') // 系统入金
      }
      if (String(ways) === '5') {
        return i18n.t('PurseFlow.ThirdpartyPayment') // 第三方支付
      }
      if (String(ways) === '6') {
        return i18n.t('PurseFlow.Cyptocurrency') // 加密货币
      }
      if (String(ways) === '7') {
        return i18n.t('Deposit.QuickPayment')
      }
      if (String(ways) === '9') {
        return i18n.t('pamm.PAMMCommission') // 提成
      }
      if (String(ways) === '10') {
        return i18n.t('pamm.PAMMPerformancefeeshare') // 分润
      }
      if (String(ways) === '11') {
        return i18n.t('pamm.PAMMransom') // 赎回
      }
      if (String(ways) === '8') {
        return i18n.t('route.pamm') + i18n.t('productList.buy') + i18n.t('Promote.cancel') // 买入取消
      }
    } else if (String(type) === '2') {
      if (String(ways) === '1') {
        return i18n.t('PurseFlow.WireTransfer') // 国际电汇
      }
      if (String(ways) === '2') {
        return i18n.t('PurseFlow.BankTransfer') // 银行汇款
      }
      if (String(ways) === '4') {
        return i18n.t('Deposit.QuickPayment')
      }
      if (String(ways) === '5') {
        return i18n.t('PurseFlow.SystematicWithdrawal') // 系统出金
      }
      if (String(ways) === '6') {
        return i18n.t('PurseFlow.Cyptocurrency') // 加密货币
      }
      if (String(ways) === '12') {
        return i18n.t('pamm.PAMMbuy') // 买入
      }
    } else if (String(type) === '3') {
      if (String(ways) === '6') {
        return i18n.t('PurseFlow.WireTransfer') // 内部转入
      }
      if (String(ways) === '7') {
        return i18n.t('PurseFlow.BankTransfer') // 内部转出
      }
      if (String(ways) === '8') {
        return i18n.t('PurseFlow.SystematicWithdrawal') // 内部转账回退
      }
    } else if (String(type) === '4') {
      if (String(ways) === '8') {
        return i18n.t('PurseFlow.Commission') // 内部转入
      }
    } else {
      return '--'
    }
  },
  hideMobile(value) {
    if (value) {
      return value.replace(/(\d{3})\d{8}/, '$1****')
    } else {
      return '***'
    }
  },
  hideEmail(value) {
    const reg = /(.{3}).+(.{0}@.+)/g
    if (value) {
      if (value.split('@')[0].length <= 3) {
        return value.split('@')[0] + '****@' + value.split('@')[1]
      } else {
        return value.replace(reg, '$1****$2')
      }
    } else {
      return '***'
    }
  },
  handlecommissionlevel(data) {
    if (data.levelName && data.level) {
      return data.levelName + '(' + data.level + ')'
    } else if (data.rebateLevel && data.level) {
      return data.rebateLevel + '(' + data.level + ')'
    } else {
      return '--'
    }
  }
}
export default filters
